import React from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { ToastContainer } from './components/ui/Toast';

function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <Routes />
        <ToastContainer />
      </ErrorBoundary>
    </AuthProvider>
  );
}

export default App;
